import { DayOfWeekTypes } from './day-of-week-types';

export const DAY_OF_WEEK_TYPE_LABEL_MAP: Record<DayOfWeekTypes, string> = {
  [DayOfWeekTypes.Monday]: 'Пн',
  [DayOfWeekTypes.Tuesday]: 'Вт',
  [DayOfWeekTypes.Wednesday]: 'Ср',
  [DayOfWeekTypes.Thursday]: 'Чт',
  [DayOfWeekTypes.Friday]: 'Пт',
  [DayOfWeekTypes.Saturday]: 'Сб',
  [DayOfWeekTypes.Sunday]: 'Нд',
};
